/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-rules-action-factory.ts to modify the generation of this file.

import { RuleActionData } from 'lib/rules/serialization';
import { RuleAction } from 'lib/rules/actions';
import { RuleContext } from 'lib/rules/rules';


import {
  HideItemOrRenderingAction,
  HideItemOrRenderingActionId
} from 'src/lib/rules/actions/HideItemOrRenderingAction';

import {
  ShowItemOrRenderingAction,
  ShowItemOrRenderingActionId
} from 'src/lib/rules/actions/ShowItemOrRenderingAction';

export function getRulesActionFactory<T extends RuleContext>(action: RuleActionData): RuleAction<T> | null {
  
  if (action.id === HideItemOrRenderingActionId) {
    const act = new HideItemOrRenderingAction(action);
    act.id = HideItemOrRenderingActionId;
    return act;
  }

  if (action.id === ShowItemOrRenderingActionId) {
    const act = new ShowItemOrRenderingAction(action);
    act.id = ShowItemOrRenderingActionId;
    return act;
  }
  return null;
};
